<app-landing-toolbar></app-landing-toolbar>
<div class="landing-content flex-container">
    <div class="signup-flex">
        <mat-card>
            <form [formGroup]="signUp" (submit)="onSubmit()">
                <div class="form-column">
                    <div>
                        <h1>Start Planning with DeckPlan!</h1>
                        <mat-form-field class="full-width">
                            <input formControlName="alias" matInput placeholder="Username" required>
                        </mat-form-field>
                        <mat-form-field class="full-width">
                            <input formControlName="email" type="email" matInput placeholder="Email" required>
                        </mat-form-field>
                        <div class="error" *ngIf="signUp.controls['email'].invalid && (signUp.controls['email'].touched || signUp.controls['email'].dirty)">
                            <mat-error *ngIf="signUp.controls['email'].errors?.email">This does not appear to be a valid email address.</mat-error>
                        </div>
                        <mat-form-field class="full-width">
                            <input formControlName="password" type="password" matInput placeholder="Password" required>
                        </mat-form-field>
                        <div class="error" *ngIf="signUp.controls['password'].invalid && (signUp.controls['password'].touched || signUp.controls['password'].dirty)">
                            <mat-error *ngIf="signUp.controls['password'].errors?.minlength">Password must be at least 8 characters.</mat-error>
                        </div>
                        <mat-form-field class="full-width">
                            <input formControlName="passwordConfirm" type="password" matInput placeholder="Confirm Password" required>
                        </mat-form-field>
                        <div class="error" *ngIf="signUp.controls['passwordConfirm'].invalid && (signUp.controls['passwordConfirm'].touched || signUp.controls['passwordConfirm'].dirty)">
                            <mat-error *ngIf="signUp.controls['passwordConfirm'].errors?.controlValueIsSame">Password fields do not match.</mat-error>
                            <mat-error *ngIf="signUp.controls['passwordConfirm'].errors?.minlength">Password must be at least 8 characters.</mat-error>
                        </div>
                        <div class="full-width radio-container">
                            <mat-radio-group aria-label="Select a payment option" formControlName="accountType">
                                <mat-radio-button value="free">Free</mat-radio-button>
                                <mat-radio-button value="planner">Planner</mat-radio-button>
                            </mat-radio-group>
                            <br>
                            <mat-hint *ngIf="signUp.get('accountType').value === 'free'">You are choosing a free account. We just wanted to let you know that we have a 50% off, lifetime subscription <a target="_blank" href="/pricing">discount</a> for early Planners!</mat-hint>
                        </div>
                        <div *ngIf="showPlannerFields" class="stripe-fields">
                            <mat-form-field class="full-width">
                                <input formControlName="fullName" matInput placeholder="Full Name">
                            </mat-form-field>
                            <div id="cardElement"></div>
                            <div class="error" *ngIf="cardError">
                                <mat-error>{{cardError}}</mat-error>
                            </div>
                            <div *ngIf="stripeError">
                                <mat-error>{{stripeError}}</mat-error>
                            </div>
                        </div>
                    </div>
                    <div>
                        <mat-checkbox formControlName="agreeToTerms"  gtagEvent trackOn="click" action="agreed_to_terms" category="legal">I agree to <a target="_blank" href="/terms" gtagEvent trackOn="click" action="terms_viewed" category="legal">terms and conditions</a> and <a target="_blank" href="/privacy" gtagEvent trackOn="click" action="privacy_viewed" category="legal">privacy policy</a>.</mat-checkbox>
                        <div class="form-footer">
                            <button class="signup-button" [disabled]="!signUp.valid || !signUp.get('agreeToTerms').value" mat-raised-button color="accent" type="submit" gtagEvent trackOn="click" action="sign_up" category="account">Start planning now!</button>
                            <a href="https://stripe.com"><img class="processor-badge" alt="Powered By Stripe" src="assets/stripe/PoweredByStripeBlurple.png"></a>
                        </div>
                    </div>
                </div>
            </form>
        </mat-card>
    </div>
    <div class="pricing-card">
        <app-pricing-block [subscriptionProduct]="currentProduct" [showSignupButton]="false" [cardMinimumHeightPx]="575"></app-pricing-block>
    </div>
</div>
